import React, { PropsWithChildren } from 'react';
import { Box, Text } from '@clariness/clarikit-react';

export const AuthPageLayoutParagraph = ({
  children,
}: PropsWithChildren<unknown>) => {
  return (
    <Box style={{ marginBottom: '34px' }}>
      <Text as="p" fontWeight="bold">
        {children}
      </Text>
    </Box>
  );
};
